import { noop, useIntl } from '@capsicum/common';
import { Divider, Image, ListCard, RadioButtonInput, type RadioButtonInputProps } from '@capsicum/common-web';
import { MIN_FAN_TOKENS_TO_WITHDRAW } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

import { type FanTokenSelectorItem } from './fan-token-selector-modal/FanTokenSelectorModal';

export type TokenSelectionListCardProps = {
	item: FanTokenSelectorItem;
	selected: boolean;
	selectToken: (tokenId: string) => void;
};

export const TokenSelectionListCard = ({ item, selected, selectToken }: TokenSelectionListCardProps) => {
	const { $t } = useIntl();

	const radioButtonProps: RadioButtonInputProps = {
		checked: selected,
		disabled: !item.enabled,
		onPress: () => selectToken(item?.id || '')
	};

	const availableToWithdrawText = $t('wallet.fantokenSelectModal.availableToWithdraw');
	const availableText = $t('wallet.fantokenSelectModal.available');
	const textWithdraw = (amount: number) => {
		return amount < (item.minAmount || MIN_FAN_TOKENS_TO_WITHDRAW) ? availableText : availableToWithdrawText;
	};

	return (
		<S.ListCardWrapper
			testID={`tokenSelection-listCard-${item?.partnerName}`}
			onClick={() => (item.enabled ? selectToken(item?.id || '') : noop)}
		>
			<S.ListCardContent>
				<ListCard.Row>
					<S.ListCardImage
						$enabled={item.enabled}
						alt={item.partnerName || ''}
						height={48}
						src={item?.url as string}
						width={48}
					/>
					<S.ListCardRowCollapsed>
						<S.ListCardTitle>{`${item?.partnerName}`}</S.ListCardTitle>
						<S.SubtitleContainer>
							<S.ListCardSubTitle>{textWithdraw(Number(item.amount) || 0)}</S.ListCardSubTitle>
							<S.ListCardSubTitleBold>{item.formattedAmount}</S.ListCardSubTitleBold>
						</S.SubtitleContainer>
					</S.ListCardRowCollapsed>
					<S.StyledRadioButton {...radioButtonProps} />
				</ListCard.Row>
				<Divider orientation="horizontal" />
			</S.ListCardContent>
		</S.ListCardWrapper>
	);
};
namespace S {
	export const ListCardWrapper = styled(ListCard)`
		width: 100%;
		cursor: pointer;
	`;
	export const ListCardContent = styled(ListCard.Content)`
		gap: ${({ theme }) => theme.spacings.medium};
	`;
	export const ListCardTitle = styled(ListCard.Title)`
		width: 100%;
		flex: 1;
	`;
	export const SubtitleContainer = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
		align-items: baseline;
	`;
	export const ListCardSubTitleBold = styled(ListCard.SubTitle)`
		${({ theme }) => theme.fonts.text.text4}
		color: ${({ theme }) => theme.colors.text.main.enabled}
	`;
	export const ListCardImage = styled(Image)<{ $enabled?: boolean }>`
		opacity: ${({ $enabled }) => ($enabled ? '1' : '0.3')};
	`;
	export const ListCardRowCollapsed = styled(ListCard.Row)`
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-left: ${({ theme }) => theme.spacings.xxsmall};
	`;
	export const ListCardSubTitle = styled(ListCard.SubTitle)`
		${({ theme }) => theme.fonts.text.caption2}
	`;
	export const StyledRadioButton = styled(RadioButtonInput)`
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
